import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import TDesign from 'tdesign-mobile-vue';
import 'tdesign-mobile-vue/es/style/index.css';
import * as Utils from '@/assets/utils';

import router from './router'
import App from './App.vue'
import CookieBanner from '@/components/cookie'
import MobileCookieBanner from '@/mobile/components/cookie'

createApp(App).use(ElementPlus).use(TDesign).use(router).component('cookie-banner', CookieBanner).component('mobile-cookie-banner', MobileCookieBanner).mount('#app');